angular.module('gym.pos').config(["$stateProvider", function($stateProvider) {
  return $stateProvider.state('gym.pos.products', {
    abstract: true,
    template: '<ui-view>'
  }).state('gym.pos.products.list', {
    url: '/products',
    template: require('templates/gyms/pos/products/index.html.slim')
  }).state('gym.pos.products.view', {
    url: '/products/:id',
    template: require('templates/gyms/pos/products/index.html.slim')
  });
}]);
